/* eslint-disable */
export const NODE_ENV = process.env.NODE_ENV
export const SANDBOX = process.env.REACT_APP_SANDBOX || 'false'
export const REACT_ENV = process.env.REACT_APP_ENV
export const API_HOST = process.env.REACT_APP_API_HOST
export const ADD_CARD_URL = process.env.REACT_APP_ADD_CARD_URL || 'https://card.flyxo.com/'
export const BRAZE_KEY = process.env.REACT_APP_BRAZE_KEY
export const DOMAIN = process.env.REACT_APP_DOMAIN
export const SALESFORCE_FORM_API_URL = process.env.REACT_APP_SALESFORCE_FORM_API_URL
export const SALESFORCE_OID = process.env.REACT_APP_SALESFORCE_OID
export const API_STRAPI_GIFTS = process.env.REACT_APP_STRAPI_API_GIFT
